export default {
  root: {
    "& div": {
      fontWeight: "900 !important",
      minWidth: "auto"
    }
  }
}
